const Vue = require('vue')

Vue.component('ui-modal', require('components/ui/Modal.vue'))



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/ui/modal.js